import React from 'react';

import './styles.css';

const HeaderLine = ({label}) => (
    <h2 className="header-line"> {label} </h2>
);

export default HeaderLine;